export const mistralModels = {
    id: "mistral",
    name: "Mistral",
    npm: "@ai-sdk/mistral",
    doc: "https://docs.mistral.ai/getting-started/models/",
    env: ["MISTRAL_API_KEY"],
    models: {
        "pixtral-large-latest": {
            id: "pixtral-large-latest",
            name: "Pixtral Large",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2024-11-01",
            last_updated: "2024-11-04",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 6,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "open-mixtral-8x7b": {
            id: "open-mixtral-8x7b",
            name: "Mixtral 8x7B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-01",
            release_date: "2023-12-11",
            last_updated: "2023-12-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.7,
                output: 0.7,
            },
            limit: {
                context: 32000,
                output: 32000,
            },
        },
        "codestral-latest": {
            id: "codestral-latest",
            name: "Codestral",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-05-29",
            last_updated: "2025-01-04",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.3,
                output: 0.9,
            },
            limit: {
                context: 256000,
                output: 4096,
            },
        },
        "devstral-small-2505": {
            id: "devstral-small-2505",
            name: "Devstral Small 2505",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-07",
            last_updated: "2025-05-07",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.3,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "devstral-medium-2507": {
            id: "devstral-medium-2507",
            name: "Devstral Medium",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-07-10",
            last_updated: "2025-07-10",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.4,
                output: 2,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "mistral-medium-2505": {
            id: "mistral-medium-2505",
            name: "Mistral Medium 3",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-07",
            last_updated: "2025-05-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.4,
                output: 2,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "devstral-small-2507": {
            id: "devstral-small-2507",
            name: "Devstral Small",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-07-10",
            last_updated: "2025-07-10",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.3,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "ministral-8b-latest": {
            id: "ministral-8b-latest",
            name: "Ministral 8B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-10-01",
            last_updated: "2024-10-04",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.1,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "magistral-medium-latest": {
            id: "magistral-medium-latest",
            name: "Magistral Medium",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-06",
            release_date: "2025-03-17",
            last_updated: "2025-03-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 5,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "pixtral-12b": {
            id: "pixtral-12b",
            name: "Pixtral 12B",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-09",
            release_date: "2024-09-01",
            last_updated: "2024-09-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.15,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "open-mistral-7b": {
            id: "open-mistral-7b",
            name: "Mistral 7B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2023-09-27",
            last_updated: "2023-09-27",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.25,
                output: 0.25,
            },
            limit: {
                context: 8000,
                output: 8000,
            },
        },
        "magistral-small": {
            id: "magistral-small",
            name: "Magistral Small",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-06",
            release_date: "2025-03-17",
            last_updated: "2025-03-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.5,
                output: 1.5,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "mistral-medium-2508": {
            id: "mistral-medium-2508",
            name: "Mistral Medium 3.1",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-08-12",
            last_updated: "2025-08-12",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.4,
                output: 2,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "open-mixtral-8x22b": {
            id: "open-mixtral-8x22b",
            name: "Mixtral 8x22B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2024-04-17",
            last_updated: "2024-04-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 6,
            },
            limit: {
                context: 64000,
                output: 64000,
            },
        },
        "mistral-medium-latest": {
            id: "mistral-medium-latest",
            name: "Mistral Medium",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-07",
            last_updated: "2025-05-10",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.4,
                output: 2,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "mistral-small-latest": {
            id: "mistral-small-latest",
            name: "Mistral Small",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03",
            release_date: "2024-09-01",
            last_updated: "2024-09-04",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.3,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "mistral-large-latest": {
            id: "mistral-large-latest",
            name: "Mistral Large",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2024-11-01",
            last_updated: "2024-11-04",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 6,
            },
            limit: {
                context: 131072,
                output: 16384,
            },
        },
        "mistral-nemo": {
            id: "mistral-nemo",
            name: "Mistral Nemo",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2024-07-01",
            last_updated: "2024-07-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.15,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "ministral-3b-latest": {
            id: "ministral-3b-latest",
            name: "Ministral 3B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-10-01",
            last_updated: "2024-10-04",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.04,
                output: 0.04,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
    },
};
export default mistralModels;
//# sourceMappingURL=mistral.js.map